@if (showEservicesLinks()) {
  <button id="td-wb-documents-link-toggle"
          class="td-wb-documents-link__anchor"
          [tdWbFlyoutMenuToggle]="flyoutMenu"
          [tdWbFlyoutMenuToggleOverlayPosition]="['end-bottom', 'end-top']">
    <td-wb-icon class="td-wb-documents-link__document"
                iconId="documents"
                [inline]="true"
                size="15x17" />
    <span id="td-wb-aria-documents-link-title"
          translate="tdWb.documentsLink.DOCUMENTS_ESERVICES">
    </span>
    <div class="td-wb-documents-link__arrow"></div>
  </button>
  <td-wb-flyout-menu #flyoutMenu="tdWbFlyoutMenu">
    <ul aria-labelledby="td-wb-aria-documents-link-title">
      @if (showStatements()) {
        <li>
          <a tdWbFlyoutMenuItem
             tdWbHref="link_eservices_statements"
             [tdWbHrefParams]="{ accountGroupId: getAccountGroupId() }">
            <span translate="tdWb.documentsLink.STATEMENTS"></span>
          </a>
        </li>
      }
      @if (showConfirmations()) {
        <li>
          <a tdWbFlyoutMenuItem
             tdWbHref="link_eservices_confirmations"
             [tdWbHrefParams]="{ accountGroupId: getAccountGroupId() }">
            <span translate="tdWb.documentsLink.CONFIRMATIONS"></span>
          </a>
        </li>
      }
      @if (showTaxStatements()) {
        <li>
          <a tdWbFlyoutMenuItem
             tdWbHref="link_eservices_tax_documents"
             [tdWbHrefParams]="{ accountGroupId: getAccountGroupId() }">
            <span translate="tdWb.documentsLink.TAX_FORMS"></span>
          </a>
        </li>
      }
      @if (showPortfolioReports()) {
        <li>
          <a tdWbFlyoutMenuItem
             tdWbHref="link_eservices_portfolio_report"
             [tdWbHrefParams]="{ accountGroupId: getAccountGroupId() }">
            <span translate="tdWb.documentsLink.PORTFOLIO_REPORT"></span>
          </a>
        </li>
      }
    </ul>
  </td-wb-flyout-menu>
}

